import React , {useEffect , useState} from 'react';
import { useParams } from 'react-router-dom';

//*Redux
import { useDispatch , useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//* import css
import cssClasses from "./Queues.module.css"

//* imports MUI
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CropFreeIcon from '@mui/icons-material/CropFree';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

//* import subComponents
import Button from '../../../Subcomponents/Button';
import Search from "../../../Subcomponents/Search";
import StatusChip from "../../../Subcomponents/LeadStatusChip";

//* import Modals
import ScanConformationModal from '../../../Modals/ScanConformationModal/ScanConformationModal';
import { getEventByEventName } from '../../../Services/Event';

function Queues() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const { eventID } = useParams();
  const [scanConformationModal, setScanConformationModal] = useState(false);
  const [EventData , setEventData] = useState([]);
  useEffect(() => {
    dispatch(action.activeMenu('queue'));
    getEventName();
  }, []);

  useEffect(() => {
    console.log("Event-Name" , eventID)
  }, [eventID])


  function getEventName() {
    getEventByEventName(eventID).then((res) => {
      console.log("Event-Data" , res)
      setEventData(res)
    })
  }
  return (
    <>
    <div className={`pageWrapper ${cssClasses.pageWrapper}`}>
      <Box className={cssClasses.headerWrapper}>
        <Box className={cssClasses.headerLeftSide}>

          <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
            <Typography className={cssClasses.headerTittle}>{EventData[0]?.title}</Typography>
            <Typography className={cssClasses.headerSubTitle}>Queue Dashboard</Typography>
          </Box>

          
          <Box className={cssClasses.dateTimeWrapper}>
            <div>
              <CalendarTodayIcon />
              <Typography className={cssClasses.headerSubTitle} color={"#000000"}>08/12/2022</Typography>
            </div>
            <div>
              <AccessTimeIcon />
              <Typography className={cssClasses.headerSubTitle} color={"#000000"}>12:00 AM</Typography>
            </div>
          </Box>
            
        </Box>

        <Box className={cssClasses.headerRightSide}>
          <div>
            <Button
              style={{
                color: "#fff",
                backgroundColor: "#1570EF",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Roboto-Regular",
              }}
              btnName={"Scan QR"}
              clicked={() => {
                setScanConformationModal(true);
              }}
              btnIcon={<CropFreeIcon style={{width: "15px", height: "15px"}}/>}
              iconPosition={"left"}
            />
          </div>
        </Box>
      </Box>

      <div className={cssClasses.mainWrapper}>

        <Box className={cssClasses.checkPointWrapper}>
          <div className={cssClasses.cardWrapper}>
            <div className={cssClasses.cardHeader}>
              <p>Check Pt.1 (5)</p>
              <div>
                <Search 
                  sxStyle={{
                    " .MuiInputBase-root": {
                      background: "#FFFFFF !important"
                    }
                  }}
                  placeholder={"Search here..."}
                  width={"18rem"}
                />
              </div>
            </div>
            <div className={cssClasses.cardContentContainer}>
              {
                Array(10).fill("").map((item, index) => (
                  <div className={cssClasses.cardContent} key={`CheckPoint_${index+1}`}>
                    <div className={cssClasses.cardTextWrapper}>
                      <p className={cssClasses.leadNameText}><span >1. </span> LEAD NAME</p>
                      <p className={cssClasses.cardText}><span >CP: </span> Mr. Rajan Kumar</p>
                      <p className={cssClasses.cardText}>PP-220801-001</p>
                      <p className={cssClasses.cardText}><span >SE: </span> Erhan Javarkar</p>
                      <Box display={"flex"} flexDirection={"row"} gap={"1rem"} alignItems={"center"} flex={"0 0 100%"}>
                        <StatusChip
                          style={{
                            color: "#6927DA",
                            backgroundColor: "#EBE9FE",
                          }}
                          label={"Priority Pass"}
                          // icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                        />
                        <p className={cssClasses.cardText}><span>VJCUID-220701-001</span></p>
                      </Box>
                    </div>
                    <div className={cssClasses.cardButtonWrapper}>
                      <button className={cssClasses.CardArrowButton}><KeyboardDoubleArrowRightIcon style={{width: "2rem", height: "2rem"}}/></button>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
          <div className={cssClasses.cardWrapper}>
            <div className={cssClasses.cardHeader}>
              <p>Check Pt.2 (10)</p>
              <div>
                <Search 
                  sxStyle={{
                    " .MuiInputBase-root": {
                      background: "#FFFFFF !important"
                    }
                  }}
                  placeholder={"Search here..."}
                  width={"18rem"}
                />
              </div>
            </div>
            <div className={cssClasses.cardContentContainer}>
              {
                Array(10).fill("").map((item, index) => (
                  <div className={cssClasses.cardContent} key={`CheckPoint_${index+1}`}>
                    <div className={cssClasses.cardTextWrapper}>
                      <p className={cssClasses.leadNameText}><span >1. </span> LEAD NAME</p>
                      <p className={cssClasses.cardText}><span >CP: </span> Mr. Rajan Kumar</p>
                      <p className={cssClasses.cardText}>PP-220801-001</p>
                      <p className={cssClasses.cardText}><span >SE: </span> Erhan Javarkar</p>
                      <Box display={"flex"} flexDirection={"row"} gap={"1rem"} alignItems={"center"} flex={"0 0 100%"}>
                        <StatusChip
                          style={{
                            color: "#6927DA",
                            backgroundColor: "#EBE9FE",
                          }}
                          label={"Priority Pass"}
                          // icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                        />
                        <p className={cssClasses.cardText}><span>VJCUID-220701-001</span></p>
                      </Box>
                    </div>
                    <div className={cssClasses.cardButtonWrapper}>
                      <button className={cssClasses.CardArrowButton}><KeyboardDoubleArrowRightIcon style={{width: "2rem", height: "2rem"}}/></button>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </Box>


        <Box className={cssClasses.passesWrapper}>
          <div className={cssClasses.cardWrapper}>
            <div className={cssClasses.cardHeader}>
              <p>Priority Pass (2)</p>
              <div>
                <Search 
                  sxStyle={{
                    " .MuiInputBase-root": {
                      background: "#FFFFFF !important"
                    }
                  }}
                  placeholder={"Search here..."}
                  width={"18rem"}
                />
              </div>
            </div>
            <div className={cssClasses.cardContentContainer}>
              {
                Array(10).fill("").map((item, index) => (
                  <div className={cssClasses.cardContent} key={`CheckPoint_${index+1}`}>
                    <div className={cssClasses.cardTextWrapper}>
                      <p className={cssClasses.leadNameText}><span >1. </span> LEAD NAME</p>
                      <p className={cssClasses.cardText}><span >CP: </span> Mr. Rajan Kumar</p>
                      <p className={cssClasses.cardText}>PP-220801-001</p>
                      <p className={cssClasses.cardText}><span >SE: </span> Erhan Javarkar</p>
                      <Box display={"flex"} flexDirection={"row"} gap={"1rem"} alignItems={"center"} flex={"0 0 100%"}>
                        <StatusChip
                          style={{
                            color: "#6927DA",
                            backgroundColor: "#EBE9FE",
                          }}
                          label={"Priority Pass"}
                          // icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                        />
                        <p className={cssClasses.cardText}><span>VJCUID-220701-001</span></p>
                      </Box>
                    </div>
                    <div className={cssClasses.cardButtonWrapper}>
                      <button className={cssClasses.CardArrowButton}><KeyboardDoubleArrowRightIcon style={{width: "2rem", height: "2rem"}}/></button>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
          <div className={cssClasses.cardWrapper}>
            <div className={cssClasses.cardHeader}>
              <p>Pre-Select (3) </p>
              <div>
                <Search 
                  sxStyle={{
                    " .MuiInputBase-root": {
                      background: "#FFFFFF !important"
                    }
                  }}
                  placeholder={"Search here..."}
                  width={"18rem"}
                />
              </div>
            </div>
            <div className={cssClasses.cardContentContainer}>
              {
                Array(10).fill("").map((item, index) => (
                  <div className={cssClasses.cardContent} key={`CheckPoint_${index+1}`}>
                    <div className={cssClasses.cardTextWrapper}>
                      <p className={cssClasses.leadNameText}><span >1. </span> LEAD NAME</p>
                      <p className={cssClasses.cardText}><span >CP: </span> Mr. Rajan Kumar</p>
                      <p className={cssClasses.cardText}>PP-220801-001</p>
                      <p className={cssClasses.cardText}><span >SE: </span> Erhan Javarkar</p>
                      <Box display={"flex"} flexDirection={"row"} gap={"1rem"} alignItems={"center"} flex={"0 0 100%"}>
                        <StatusChip
                          style={{
                            color: "#6927DA",
                            backgroundColor: "#EBE9FE",
                          }}
                          label={"Priority Pass"}
                          // icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                        />
                        <p className={cssClasses.cardText}><span>VJCUID-220701-001</span></p>
                      </Box>
                    </div>
                    <div className={cssClasses.cardButtonWrapper}>
                      <button className={cssClasses.CardArrowButton}><KeyboardDoubleArrowRightIcon style={{width: "2rem", height: "2rem"}}/></button>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </Box>


      </div>
    </div>

    {/** Imports Modals */}
    <ScanConformationModal 
      open={scanConformationModal}
      handleClose={() => {
        setScanConformationModal(false);
      }}
    />
  </>
  )
}

export default Queues